import api from './api';

export interface SttMeetingDto {
  id: string;
  summary: string;
  start: string | null;
  end: string | null;
  htmlLink?: string | null;
}

export async function syncMeetings(): Promise<number> {
  const res = await api.post<{ success: boolean; upserted: number }>('/stt/sync', {});
  return (res.data && (res.data as any).upserted) || 0;
}

export async function listMyMeetings(scope: 'planned' | 'ended' = 'planned'): Promise<SttMeetingDto[]> {
  const res = await api.get<{ success: boolean; data: SttMeetingDto[] }>(`/stt/meetings?scope=${scope}`);
  return (res.data && (res.data as any).data) || [];
}

export interface MeetingParticipantDto {
  email: string | null;
  display_name: string | null;
  avatar_url: string | null;
}

export async function getParticipants(meetingGoogleId: string): Promise<MeetingParticipantDto[]> {
  const res = await api.get<{ success: boolean; data: MeetingParticipantDto[] }>(`/stt/participants?meeting=${encodeURIComponent(meetingGoogleId)}`);
  return (res.data && (res.data as any).data) || [];
}

export default { syncMeetings, listMyMeetings };


